function getFdBaseUrl() {
  const runtime = useRuntimeConfig();
  const base = runtime.public.FD_API_BASE_URL || "https://prod-api.equirize.com";
  return base.replace(/\/$/, "");
}

class FdService {
  async getFdSources() {
    const url = `${getFdBaseUrl()}/fd-cb/fd/sources`;
    return $fetch(url, {
      headers: { "Content-Type": "application/json" },
      method: "GET",
    });
  }
}

export default new FdService();
